import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX, FiSearch } from "react-icons/fi";
import SearchPopup from "./SearchPopup";

const NavbarPortal = () => {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="w-full bg-white shadow-sm sticky top-0 z-50 font-signika">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-[70px]">
          {/* LOGO */}
          <NavLink to="/" className="flex items-center gap-2">
            <img src="/images/logo08.png" alt="Merah Putih" className="h-10" />
          </NavLink>

          {/* MENU DESKTOP */}
          <nav className="hidden lg:flex items-center gap-7 font-medium text-gray-700">
            <NavLink to="/">Beranda</NavLink>
            <NavLink to="/tentangkami">Tentang</NavLink>
            <NavLink to="/astacita">Asta Cita</NavLink>
            <NavLink to="/tujuanprogram">Tujuan Program</NavLink>
            <NavLink to="/kategori/nasional">Nasional</NavLink>
            <NavLink to="/kategori/politik">Politik</NavLink>
            <NavLink to="/kategori/ekonomi">Ekonomi</NavLink>
            {/* <NavLink to="/kategori/opini">Olahraga</NavLink>
            <NavLink to="/kategori/teknologi">Teknologi</NavLink> */}
            <NavLink to="/kategori/internasional">Internasional</NavLink>
            <NavLink to="/kategori/semua">Berita</NavLink>
          </nav>

          {/* SEARCH */}
          <div className="hidden lg:flex">
            <FiSearch className="text-xl cursor-pointer" onClick={() => setSearchOpen(true)} />
          </div>

          <div className="flex items-center gap-4 lg:hidden">
            <FiSearch size={24} className="cursor-pointer" onClick={() => setSearchOpen(true)} />

            <button onClick={() => setOpen(!open)}>{open ? <FiX size={28} /> : <FiMenu size={28} />}</button>
          </div>
        </div>
      </div>

      {/* MOBILE MENU SMOOTH */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? "max-h-[400px] opacity-100 border-t" : "max-h-0 opacity-0"}`}>
        <div className="flex flex-col items-center gap-5 py-6 font-medium bg-white">
          <NavLink to="/" onClick={() => setOpen(false)}>
            Beranda
          </NavLink>
          <NavLink to="/tentangkami" onClick={() => setOpen(false)}>
            Tentang Kami
          </NavLink>
          <NavLink to="/astacita" onClick={() => setOpen(false)}>
            Asta Cita
          </NavLink>
          <NavLink to="/tujuanprogram" onClick={() => setOpen(false)}>
            Tujuan Program
          </NavLink>

          <NavLink to="/kategori/nasional" onClick={() => setOpen(false)}>
            Nasional
          </NavLink>

          <NavLink to="/kategori/politik" onClick={() => setOpen(false)}>
            Politik
          </NavLink>

          <NavLink to="/kategori/ekonomi" onClick={() => setOpen(false)}>
            Ekonomi
          </NavLink>

          <NavLink to="/kategori/internasional" onClick={() => setOpen(false)}>
            Internasional
          </NavLink>

          {/* <NavLink to="/kategori/olahraga" onClick={() => setOpen(false)}>
            Olahraga
          </NavLink> */}

          {/* <NavLink to="/kategori/teknologi" onClick={() => setOpen(false)}>
            Teknologi
          </NavLink> */}

          <NavLink to="/kategori/semua" onClick={() => setOpen(false)}>
            Berita
          </NavLink>
        </div>
      </div>
      <SearchPopup open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>
  );
};

export default NavbarPortal;
